// extracted by mini-css-extract-plugin
export default {"cancelButton":"BankIdVerifyModal_cancelButton__yr7XC","hideOnMobile":"BankIdVerifyModal_hideOnMobile__pOKyB","hideOnDesktop":"BankIdVerifyModal_hideOnDesktop__KjeGs"};